/* KB wishlist ("Saved"). Modelled on the SA store's scp-saved / scp-wishlist.js.
   localStorage "kb-saved" = array of product ids (most recent last). Saved items stay on this device.
   - [data-kb-save="<id>"] hearts toggle the id and show .is-saved / aria-pressed
   - [data-kb-saved-count] badges show the number saved
   - /pages/saved (sections/kb-saved.liquid): clones the matching hidden <template data-kb-tpl="<id>">
     cards into the grid, sorts, shows the empty state, "Clear all" */
(function () {
  if (window.kbSaved) return;
  var KEY = 'kb-saved';
  function get() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v.map(String) : []; } catch (e) { return []; } }
  function set(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }

  function sync() {
    var saved = get();
    document.querySelectorAll('[data-kb-save]').forEach(function (b) {
      var on = saved.indexOf(b.getAttribute('data-kb-save')) !== -1;
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-kb-saved-count]').forEach(function (el) { el.textContent = saved.length; el.hidden = saved.length < 1; });
  }

  function toggle(id) {
    var saved = get();
    var i = saved.indexOf(id);
    if (i === -1) saved.push(id); else saved.splice(i, 1);
    set(saved);
    sync();
    document.dispatchEvent(new CustomEvent('kb:saved:change', { detail: { id: id, saved: i === -1 } }));
    return i === -1;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kb-save]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(b.getAttribute('data-kb-save'));
    if (on) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); }
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); page(); } });

  // ---- /pages/saved
  function page() {
    var root = document.querySelector('[data-kb-saved-page]');
    if (!root) return;
    var grid = root.querySelector('[data-kb-saved-grid]');
    var empty = root.querySelector('[data-kb-saved-empty]');
    var bar = root.querySelector('[data-kb-saved-bar]');
    var count = root.querySelector('[data-kb-saved-total]');
    var sort = root.querySelector('[data-kb-saved-sort]');
    var clear = root.querySelector('[data-kb-saved-clear]');
    var recs = root.querySelector('[data-kb-saved-recs]');
    var recsTitle = root.querySelector('[data-kb-saved-recs-title]');
    var catalog = {};
    root.querySelectorAll('template[data-kb-tpl]').forEach(function (t) {
      catalog[t.getAttribute('data-kb-tpl')] = { html: t.innerHTML, price: parseInt(t.getAttribute('data-price'), 10) || 0 };
    });
    var ids = get().filter(function (id) { return catalog[id]; });
    var mode = sort ? sort.value : 'recent';
    if (mode === 'recent') ids = ids.slice().reverse();
    else ids = ids.slice().sort(function (a, b) { return mode === 'price-low' ? catalog[a].price - catalog[b].price : catalog[b].price - catalog[a].price; });
    var n = ids.length;
    empty.hidden = n > 0;
    bar.hidden = n === 0;
    grid.hidden = n === 0;
    if (clear) clear.hidden = n === 0;
    if (count) count.textContent = n + (n === 1 ? (root.getAttribute('data-kb-t-item-one') || ' item saved') : (root.getAttribute('data-kb-t-item-other') || ' items saved'));
    grid.innerHTML = ids.map(function (id) { return catalog[id].html; }).join('');
    if (recs) {
      recs.hidden = n >= 3;
      if (recsTitle) recsTitle.textContent = n === 0 ? (root.getAttribute('data-kb-t-popular') || 'Popular right now') : (root.getAttribute('data-kb-t-also') || 'You might also like');
      recs.querySelectorAll('[data-kb-rec]').forEach(function (r) { r.hidden = ids.indexOf(r.getAttribute('data-kb-rec')) !== -1; });
    }
    sync();
  }

  function boot() {
    sync();
    page();
    var root = document.querySelector('[data-kb-saved-page]');
    if (!root) return;
    var sort = root.querySelector('[data-kb-saved-sort]');
    if (sort) sort.addEventListener('change', page);
    document.addEventListener('kb:saved:change', page);
    var clear = root.querySelector('[data-kb-saved-clear]');
    var confirmBox = root.querySelector('[data-kb-saved-confirm]');
    if (clear && confirmBox) {
      clear.addEventListener('click', function () { confirmBox.hidden = false; });
      confirmBox.addEventListener('click', function (e) {
        if (e.target.closest('[data-kb-saved-confirm-yes]')) { set([]); confirmBox.hidden = true; page(); }
        else if (e.target.closest('[data-kb-saved-confirm-no]')) confirmBox.hidden = true;
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.kbSaved = { get: get, toggle: toggle, sync: sync };
})();
